<i18n src="@/locales/views/home_app.yml" lang="yaml"></i18n>
<template>
  <div>
    <agro-exporter-dashboard v-if="user_is_agro_exporter" />
    <producer-dashboard v-if="user_is_producer" />
  </div>
</template>

<script>
import AgroExporterDashboard from "@/components/views/dashboard/AgroExporter.vue";
import ProducerDashboard from "@/components/views/dashboard/Producer.vue";

export default {
  name: "HomeApp",
  components: { AgroExporterDashboard, ProducerDashboard },
  computed: {
    user_name() {
      return this.$store.state.user.user_full_name;
    }
  },
  created() {
    this.checkIfAuthenticated();
  }
};
</script>
